import React, { FunctionComponent } from 'react';

import { isString } from 'lodash';
import { useTranslation } from 'react-i18next';

import { ContextProps } from 'reviews2/feed/review-yeti/Review.types';

import 'reviews2/feed/review-yeti/poster/ReviewPoster.scss';

export const ReviewPoster: FunctionComponent<ContextProps> = ({ context }) => {
    const { t } = useTranslation('reviews2');
    const { review } = context;
    const { showReviewerName, reviewerOptions } = context.options!;

    if (!review) {
        return null;
    }

    return (
        <div className="r4e-review-poster inline">
            {review.author_picture_url ? (
                <div className="r4e-review-poster-image">
                    <img src={review.author_picture_url} alt="" />
                </div>
            ) : (
                <div className="r4e-review-poster-no-image">
                    <i className="icon-user" />
                </div>
            )}
            {/* eslint-disable-next-line */}
            {showReviewerName ? (
                <div className="r4e-review-poster-name">
                    {review.author_real_name ? review.author_real_name : t('ANONYMOUS_USER')}
                </div>
            ) : isString(reviewerOptions?.replaceNameWith) ? (
                reviewerOptions?.replaceNameWith
            ) : (
                '********'
            )}
        </div>
    );
};
